var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-select-product"},_vm._l((_vm.lineItems),function(lineItem){return _c('div',{key:lineItem.id,staticClass:"c-select-product__product"},[_c('SelectProductCard',{attrs:{"line-item":lineItem},on:{"checkboxChanged":_vm.CheckboxChanged}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }